import { render, staticRenderFns } from "./OcrEdit.vue?vue&type=template&id=bd46473a&scoped=true&"
import script from "./OcrEdit.vue?vue&type=script&lang=js&"
export * from "./OcrEdit.vue?vue&type=script&lang=js&"
import style0 from "./OcrEdit.vue?vue&type=style&index=0&id=bd46473a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd46473a",
  null
  
)

export default component.exports